import { render, staticRenderFns } from "./MalattieInfettiveViewComponent.vue?vue&type=template&id=e975b0c6"
import script from "./MalattieInfettiveViewComponent.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports